export const getCheckboxLabel = (label) => {
  return typeof label === 'string' ? label.trim() : label;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Checkbox/utils/checkboxHelpers.js